import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { LoadingDialogService, UsuarioService } from '@sigepe/sigepe-template';

import { DetalharLaudoService } from '../services/detalhar-laudo.service';
import { PerfisEnum } from '@app/core/enums/perfis.enum';

@Component({
	selector: 'sgp-detalhar-laudo',
	templateUrl: './detalhar-laudo.component.html'
})
export class DetalharLaudoComponent implements OnInit {
	idCandidato?: number;
	idCargo?: number;
	exibirAbaPontuacao = false;

	constructor(
		private router: Router,
		private loadingDialogService: LoadingDialogService,
		private route: ActivatedRoute,
		protected detalharLaudoService: DetalharLaudoService,
		private usuarioService: UsuarioService
	) {}

	ngOnInit(): void {
		this.loadingDialogService.hideDialog();
		this.obterParametros();
		this.verificarPerfilPontuacao();
		if (this.idCandidato && this.idCargo) {
			this.detalharLaudoService.detalharLaudo(this.idCandidato);
			this.detalharLaudoService.detalharQuestionariocandidato(this.idCandidato);
			this.detalharLaudoService.detalharCargo(this.idCargo);
			this.detalharLaudoService.downloadGraficoRadar(this.idCandidato);
			this.detalharLaudoService.downloadGraficoLinhas(this.idCandidato);
			this.detalharLaudoService.downloadGraficoBarras(this.idCandidato);
			this.detalharLaudoService.detalharPontuacao(this.idCandidato);
			this.detalharLaudoService.obterAtividades(this.idCargo);
		}
	}

	voltar(): void {
		this.router.navigate(['perfilProfissiografico/pesquisarLaudo'], { queryParams: { preservarParametros: true } });
	}

	private obterParametros() {
		this.idCandidato = Number(this.route.snapshot.paramMap.get('id'));
		this.idCargo = Number(this.route.snapshot.paramMap.get('idCargo'));
	}

	private verificarPerfilPontuacao() {
		const perfisUsuario = this.usuarioService.getUsuario().perfis;
		this.exibirAbaPontuacao = perfisUsuario?.includes(PerfisEnum.PESQUISADOR) || perfisUsuario?.includes(PerfisEnum.GESTOR_PRODUTO);
	}
}
